import { render, staticRenderFns } from "./VendorsProducts.vue?vue&type=template&id=6cb13d86&scoped=true&"
import script from "./VendorsProducts.vue?vue&type=script&lang=js&"
export * from "./VendorsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb13d86",
  null
  
)

export default component.exports